import { problemText, useApiProblem } from '@/shared/api';
import { SurfaceLoadError } from '@/shared/components';

/** Ladefehler der Belegung mit dem Grund aus der API (`problemText`). */
export function CalendarLoadError({
  error,
  onRetry,
  retrying,
}: {
  error: unknown;
  onRetry: () => void;
  retrying: boolean;
}) {
  const problem = useApiProblem(error);
  return (
    <SurfaceLoadError
      message={problemText(problem, 'Die Belegung konnte nicht geladen werden.')}
      onRetry={onRetry}
      retrying={retrying}
    />
  );
}

/** Hinweiszeile unter dem Raster am Handy (Board „Belegung · Handy“). */
export function CalendarMobileHint({ manager }: { manager: boolean }) {
  return (
    <p className="text-ink-soft px-1.5 text-xs">
      {manager
        ? 'Balken antippen für Details · freien Tag antippen für eine manuelle Buchung'
        : 'Balken antippen für Zeitraum und Preis'}
    </p>
  );
}
